import React from 'react'
import { ActivityMonitor } from 'view/shared/activityMonitor'
import { PortalCreator } from 'view/shared/portal'
import { ShellWrapper, MainWrapper } from './shellLayout'

interface ShellBrowserProps {
  children?: React.ReactNode
}

export class ShellBrowser extends React.Component<ShellBrowserProps> {
  render() {
    return (
      <ShellWrapper>
        <MainWrapper>{this.props.children}</MainWrapper>
        <PortalCreator portalName="ActivityMonitorPortal">
          <ActivityMonitor />
        </PortalCreator>
      </ShellWrapper>
    )
  }
}
